"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actionCreators = exports.reopenCart = exports.removeLoyalty = exports.addLoyalty = exports.defrostCart = exports.freezeCart = exports.getCartHash = exports.cancelRecoverCart = exports.recoverCart = exports.deleteCart = exports.removeItemFromCart = exports.addItemToCart = exports.getCart = void 0;
const Service = __importStar(require("../service"));
const types_1 = require("./types");
const utils_1 = require("./utils");
const actionFactory = (endpoint, type) => (state, dispatch) => (...args) => {
    dispatch({ type: types_1.ActionTypes.REQUEST, payload: [...args, endpoint === Service.addLoyalty] });
    return endpoint(...args)
        .then((0, utils_1.handleSuccess)(dispatch, type))
        .catch((0, utils_1.handleFailure)(dispatch, types_1.ActionTypes[`${type}_FAILED`]));
};
exports.getCart = actionFactory(Service.getCart, types_1.ActionTypes.GET_CART);
exports.addItemToCart = actionFactory(Service.addItemToCart, types_1.ActionTypes.ADD_ITEM_CART);
exports.removeItemFromCart = actionFactory(Service.removeItemFromCart, types_1.ActionTypes.REMOVE_ITEM_CART);
exports.deleteCart = actionFactory(Service.deleteCart, types_1.ActionTypes.DELETE_CART);
exports.recoverCart = actionFactory(Service.recoverCart, types_1.ActionTypes.RECOVER_EXPIRED_CART);
exports.cancelRecoverCart = actionFactory(Service.cancelRecoverCart, types_1.ActionTypes.CANCEL_RECOVER_CART);
const getCartHash = () => (state, dispatch) => Service.getCartHash()
    .then((res) => {
    dispatch({
        type: types_1.ActionTypes.GET_DETAILED_CART,
        payload: { hash: res.data.cart_hash },
    });
})
    .catch((0, utils_1.handleFailure)(dispatch, types_1.ActionTypes.GET_DETAILED_CART_FAILED));
exports.getCartHash = getCartHash;
exports.freezeCart = actionFactory(Service.freezeCart, types_1.ActionTypes.FREEZE_CART);
exports.defrostCart = actionFactory(Service.defrostCart, types_1.ActionTypes.DEFROST_CART);
exports.addLoyalty = actionFactory(Service.addLoyalty, types_1.ActionTypes.ADD_LOYALTY);
exports.removeLoyalty = actionFactory(Service.removeLoyalty, types_1.ActionTypes.REMOVE_LOYALTY);
exports.reopenCart = actionFactory(Service.reopenCart, types_1.ActionTypes.REOPEN_CART);
exports.actionCreators = {
    getCart: exports.getCart,
    addItemToCart: exports.addItemToCart,
    removeItemFromCart: exports.removeItemFromCart,
    deleteCart: exports.deleteCart,
    recoverCart: exports.recoverCart,
    cancelRecoverCart: exports.cancelRecoverCart,
    freezeCart: exports.freezeCart,
    defrostCart: exports.defrostCart,
    addLoyalty: exports.addLoyalty,
    removeLoyalty: exports.removeLoyalty,
    reopenCart: exports.reopenCart,
};
